import { EditProfileAddressAvailableFieldsFn } from '../types';

export const editProfileAddressAvailableFieldsFn: EditProfileAddressAvailableFieldsFn = () => [
  {
    type: 'select',
    name: 'state',
    formName: 'state',
    placeholder: $localize`State`
  },
  {
    type: 'text',
    name: 'firstAddress',
    formName: 'address_1',
    placeholder: $localize`Address`
  },
  {
    type: 'text',
    name: 'city',
    formName: 'city',
    placeholder: $localize`City`
  },
  {
    type: 'text',
    name: 'postalCode',
    formName: 'postal_code',
    placeholder: $localize`Post code`
  },
  {
    type: 'select',
    name: 'language',
    formName: 'language',
    placeholder: $localize`Language`
  }
];
